// MUI
import { Grid } from "@mui/material";

// Components
import TextIconMessage from "@Layouts/components/Basics/TextIconMessage";
import { DATE_FORMAT } from "@/Constants/date";
import { getFormattedDate } from "@dealerwave/dw-layer-date-converter";
import { useLocation } from "@/Common/hooks/Location/useLocation";

export interface UpdatedOnProps {
	isLoading: boolean;
	updatedOn?: Date;
}

export default function UpdatedOn(props: Readonly<UpdatedOnProps>) {
	const { isLoading, updatedOn } = props;
	const { timezone } = useLocation();
	if (!isLoading && !updatedOn) {
		return null;
	}

	return (
		<Grid item className="pt-5 px-2">
			<TextIconMessage
				icon
				loading={isLoading}
				title={"Updated on"}
				showContent
				content={getFormattedDate(updatedOn, timezone, DATE_FORMAT.abbrDatePaddedTime12h)}
				sxIcon={{ color: "#666" }}
			/>
		</Grid>
	);
}
